// extracted by css-extract-rspack-plugin
export default {"Box_0":"FilterInputIcon-module__Box_0__Lecf8vV","Octicon_0":"FilterInputIcon-module__Octicon_0__RkPG3VK"};